import { HttpErrorResponse } from '@angular/common/http';

export class AgencyActionResult {
  constructor(public actionType: ActionType, public httpErrorResponse: HttpErrorResponse | null, public isSuccess: boolean) {}
}
export enum ActionType {
  UpdateAgencyDetails = 'UpdateAgencyDetails',
  UpdateAgencyCategory = 'UpdateAgencyCategory',
}
